import { getJobsColorPalette } from 'dashboard409a/hooks/useJobsColorPalette';
import {
  DEFAULT_JOBS_COLOR_PALETTE,
  JOBS_EVENT_COLORS,
  JOBS_STATUS_LABELS,
} from 'dashboard409a/pages/Workboard/common/constants';
import type { JobsColorPalette } from 'dashboard409a/pages/Workboard/common/constants';
import { ValuationStatus } from 'dashboard409a/pages/Workboard/common/types';

const LABEL_TO_PALETTE_KEY = {
  ...Object.fromEntries(Object.entries(ValuationStatus).map(([key, value]) => [value, key])),
  ...Object.fromEntries(Object.entries(JOBS_STATUS_LABELS).map(([key, value]) => [value, key])),
} as Record<string, keyof JobsColorPalette>;

const isJobsColorPaletteKey = (value: string): value is keyof JobsColorPalette =>
  value in DEFAULT_JOBS_COLOR_PALETTE;

export const getValuationStatusPaletteKey = (
  label: string
): keyof JobsColorPalette | undefined => {
  if (isJobsColorPaletteKey(label)) {
    return label;
  }

  return LABEL_TO_PALETTE_KEY[label];
};

export const getValuationStatusPaletteColorByKey = (
  paletteKey: keyof JobsColorPalette,
  palette: JobsColorPalette = getJobsColorPalette()
): string => palette[paletteKey] || JOBS_EVENT_COLORS.DEFAULT;

export const getValuationStatusPaletteColor = (
  label?: string,
  palette: JobsColorPalette = getJobsColorPalette()
): string | undefined => {
  if (!label) {
    return undefined;
  }

  const statusKey = getValuationStatusPaletteKey(label);
  if (!statusKey) {
    return undefined;
  } // non-valuation usages (tasks, model status) -> default primary

  return getValuationStatusPaletteColorByKey(statusKey, palette);
};
